import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

export class DashboardMetricsAPI {
    static async getCatalog(token) {
        const res = await server('/dashboard-metrics/catalog', {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Options of the consolidated sales table: row dimensions, default channels and the machine types they are built from
    static async getConsolidatedOptions(token) {
        const res = await server('/dashboard-metrics/consolidated/options', {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async resolveDashboardMetrics(data, token) {
        const res = await server('/dashboard-metrics/resolve', {
            method: 'POST',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }
}
